import { deepMerge } from "../../object/deepMerge";
import ExtendedError from "../ExtendedError";
import isChunkLoadError from "../isChunkLoadError";
import isError from "../isError";
const errorReportingDataExtractionRegistry = [];
/**
 * Registers a function that can extract data (tags, extra, ...) for the error
 * reporting
 */
export const registerErrorReportingDataExtractionFn = (fn) => {
    errorReportingDataExtractionRegistry.push(fn);
};
export const extractErrorReportingData = (error) => {
    let mergedResult = {};
    for (const extractor of errorReportingDataExtractionRegistry) {
        const extracted = extractor(error);
        if (extracted) {
            mergedResult = deepMerge(mergedResult, extracted);
        }
    }
    if (error instanceof ExtendedError) {
        const cause = error.cause();
        if (cause) {
            const nestedResult = extractErrorReportingData(cause);
            if (nestedResult) {
                mergedResult = deepMerge(nestedResult, mergedResult);
            }
        }
    }
    if (Object.keys(mergedResult).length > 0) {
        return mergedResult;
    }
};
/** Some default reporting data extraction functions */
registerErrorReportingDataExtractionFn((error) => {
    // Do not report fetch-mock-error
    if (isError(error) && error.message.startsWith("fetch-mock")) {
        return {
            noReport: true,
        };
    }
});
registerErrorReportingDataExtractionFn((error) => {
    // Extract error infos from ExtendedError
    if (error instanceof ExtendedError) {
        return {
            extra: ExtendedError.info(error),
        };
    }
});
registerErrorReportingDataExtractionFn((error) => {
    // Do not report ChunkLoadErrors
    if (isChunkLoadError(error)) {
        return {
            noReport: true,
        };
    }
});
//# sourceMappingURL=data:application/json;base64,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